// extracted by mini-css-extract-plugin
export default {"maincontainer":"LoginSignup_maincontainer__euOrR","leftcontainer":"LoginSignup_leftcontainer__MY9ot","rightcontainer":"LoginSignup_rightcontainer__uqTlk"};